<template>
  <span>
    <v-overlay :value="isLoading" absolute opacity="0.7" z-index="1000">
      <v-progress-circular
        indeterminate
        color="accent"
        :size="50"
        :width="5"
      ></v-progress-circular>
    </v-overlay>
    <delete-course ref="deleteCourse" @didDestroy="doClose"></delete-course>
    <v-dialog v-model="isOpen" persistent max-width="1200px">
      <v-card class="ma-0 overflow-y-hidden">
        <v-card-title>
          <span class="text-h5">Course Information</span>
        </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="doUpdate" fast-fail ref="form">
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-select
                      outlined
                      :items="organizations"
                      v-model="course.organizationId"
                      item-text="name"
                      item-value="id"
                      label="Organization"
                      :rules="inputs.rules.simplyRequired"
                    >
                      <template v-slot:item="{ item }">
                        <v-avatar size="42">
                          <v-img contain :src="item.logoUrl"></v-img>
                        </v-avatar>
                        <span class="ml-2">
                          {{ item.name }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-avatar size="42">
                          <v-img contain :src="item.logoUrl"></v-img>
                        </v-avatar>
                        <span class="ml-2">
                          {{ item.name }}
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col>
                    <v-text-field outlined label="Name" v-model="course.name" hint="Official Course Name" :rules="inputs.rules.simplyRequired"></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-textarea outlined v-model="course.subtitle" label="Subtitle" hint="Short description of the Course" no-resize rows="2" :rules="inputs.rules.simplyRequired"></v-textarea>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-btn @click="doOpenWysiwygEditor()" depressed outlined tile large block plain class="rounded">Content and Description</v-btn>
                  </v-col>
                </v-row>
                 <v-row>
                 <v-col>
                    <v-checkbox v-model="areImagesSetDuringValidation" off-icon="fa-regular fa-square" :rules="inputs.rules.simplyRequired" style="display: none;" :disabled="true"></v-checkbox>
                    <image-upload-and-shuffle ref="images" :class="areImagesSetDuringValidation ? 'rounded' : 'customError rounded'" @change="doLoadImages"></image-upload-and-shuffle>
                    <span class="caption red--text ml-2" v-if="!areImagesSetDuringValidation">At least one image is required</span>
                 </v-col>
                 <v-col>
                    <v-text-field prepend-icon="fa-dollar-sign" label="Cost" v-model.number="costAmount" outlined hint="Cost for the course" :rules="inputs.rules.simplyRequired"></v-text-field>
<!--                    <v-card>-->
<!--                      <v-card-text>-->
<!--                        <span>Cost breakdown information</span>-->
<!--                        <ul>-->
<!--                          <li class="caption">Course cost: <span class="font-weight-bold">$ {{ costAmount.toFixed(2) }}</span></li>-->
<!--                          <li class="caption">Sales Tax (if applicable): <span class="font-weight-bold">9% ( $ {{ (costAmount * 0.09).toFixed(2) }} )</span></li>-->
<!--                          <li class="caption">Total checkout price for one: <span class="font-weight-bold">$ {{ (costAmount * 1.09).toFixed(2) }}</span></li>-->
<!--                        </ul>-->
<!--                      </v-card-text>-->
<!--                    </v-card>-->
                 </v-col>
                 </v-row>
                 <v-row>
                  <v-col>
                    <v-btn @click="doClose">Cancel</v-btn>
                  </v-col>
                  <v-col align="right">
                    <v-btn @click="doDeleteCourse" color="red" class="mr-3 white--text" :disabled="userRole === 'employee'">Delete</v-btn>
                    <v-btn type="submit" color="success" :disabled="userRole === 'employee'">Update</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
      </v-card>
    </v-dialog>
    <wysiwyg-editor ref="editor" @Save="doSaveCourseContent"></wysiwyg-editor>
  </span>
</template>

<script>
import DeleteCourse from '@/views/admin/courses/deleteCourse'
import WysiwygEditor from '@/components/tools/wysiwygEditor.vue'
import ImageUploadAndShuffle from '@/components/image/ImageUploadAndShuffle.vue'

export default {
  name: 'viewCourse',
  components: { ImageUploadAndShuffle, WysiwygEditor, DeleteCourse },
  data: () => ({
    isLoading: false,
    isOpen: false,
    organizations: [],
    isValidated: null,
    course: {
      id: 0,
      name: String(),
      subtitle: String(),
      content: String(),
      organizationId: Number(),
      images: [],
      cents: Number()
    },
    userRole: null
  }),
  computed: {
    costAmount: {
      get: function () {
        return (this.course.cents / 100)
      },
      set: function (newValue) {
        this.course.cents = newValue * 100
      }
    },
    areImagesSetDuringValidation () {
      if (this.isValidated !== null) {
        return (this.course.images.length >= 1)
      } else {
        return true
      }
    }
  },
  methods: {
    doOpen (id) {
      this.doInit()
      this.course.id = id
      this.userRole = this.$store.getters.doGetRole
      this.isLoading = true

      new Promise((resolve, reject) => {
        this.$services.course.organization.doReadAll().then(organizations => {
          this.$services.course.doRead(this.course.id).then(course => {
            this.organizations = organizations
            this.course = course
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      }).then(_ => {
        this.isOpen = true
      }).catch(error => {
        this.$root.$emit('showError', error.message)
      }).finally(_ => {
        this.$refs.images.doDefineImages(this.course.images)
        this.$refs.form.resetValidation()
        this.isLoading = false
      })
    },
    doClose () {
      this.isOpen = false
      this.$emit('doLoad')
    },
    doLoadImages () {
      this.course.images = this.$refs.images.images.filter(image => image.url != null)
    },
    doUpdate () {
      this.doLoadImages()

      this.isValidated = this.$refs.form.validate()

      if (this.isValidated && (this.course.images.length >= 1)) {
        this.isLoading = true

        this.$services.course.doUpdate(this.course.id, this.course.name, this.course.subtitle, this.course.content, this.course.organizationId, this.course.images, this.course.cents, this.course.queueMinimum).then(_ => {
          this.doClose()
        }).catch(error => {
          this.$root.$emit('showError', error.message)
        }).finally(_ => {
          this.isLoading = false
        })
      }
    },
    doOpenWysiwygEditor () {
      this.$refs.editor.doOpen('Content and Description', this.course.content)
    },
    doSaveCourseContent (content) {
      this.course.content = content
    },
    doDeleteCourse () {
      this.$refs.deleteCourse.doOpen(this.course.id)
    },
    doInit () {
      this.isValidated = null
      this.course = {
        id: 0,
        name: String(),
        subtitle: String(),
        content: String(),
        organizationId: Number(),
        images: [],
        cents: Number()
      }
    }
  }
}
</script>

<style scoped>
::v-deep .tiptap-vuetify-editor__content {
  height: 300px;
}
.customError {
  border: 2px red solid;
  color: red;
}
</style>
